import { useLocation } from 'react-router-dom';

/** True when the screen is under the FIC /management shell. */
export default function useInLeadershipShell() {
  return useLocation().pathname.startsWith('/management');
}
